import { Breakpoints } from "./breakpoints";

const LOCATION_TOP = 0;
const LOCATION_MAIN = 1;

if (Node.prototype.appendChildren === undefined) {
  Node.prototype.appendChildren = function () {
    let children = [...arguments];

    if (
      children.length == 1 &&
      Object.prototype.toString.call(children[0]) === "[object Array]"
    ) {
      children = children[0];
    }

    const documentFragment = document.createDocumentFragment();
    children.forEach(c => documentFragment.appendChild(c));
    this.appendChild(documentFragment);
  };
}

export class NavTop {

  constructor() {
    this.currentLocation = LOCATION_TOP

    this.navTop = document.getElementById('nav-top').querySelector('ul')
    this.navMain = document.getElementById('nav-main').querySelector('ul')

    this.breakpoints = new Breakpoints();
    this.breakpoints.on('changed', this.updateNavTop.bind(this));
    this.updateNavTop();

  }

  moveToNavMain() {
    for (const node of this.navTop.children) {
      node.classList.add("-from-nav-top")
    }
    this.navMain.appendChildren.apply(this.navMain, [this._createDivider(), ...this.navTop.children])
  }

  moveToNavTop() {
    this._removeDivider();
    this.navTop.appendChildren.apply(this.navTop, document.querySelectorAll('.-from-nav-top'))
  }

  updateNavTop() {
    let newLocation = this.breakpoints.breakpointUp('md') ? LOCATION_TOP : LOCATION_MAIN;

    if (newLocation !== this.currentLocation) {
      this.currentLocation = newLocation;
      this.currentLocation === LOCATION_MAIN ? this.moveToNavMain() : this.moveToNavTop()
    }
  }

  _removeDivider() {
    const divider = document.querySelector('.top-nav-divider');
    divider.remove();
  }

  _createDivider() {
    const dividerLi = document.createElement('li')
    dividerLi.textContent = 'divider'
    dividerLi.classList.add("top-nav-divider")
    return dividerLi;
  }

}